import StoriesUserPublished from "%/dynamic-component-editor/standard-elements/StoriesUserPublished.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyPublishedStories extends LegacyEntity {
  get elements() {
    return {
      StoriesUserPublished,
    };
  }
}
